import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.healthcheck.methods.ExposedMethods';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class ExposedMethods extends RpcClass{

    /**
     *  @class ExposedMethods
     *  @alias module:src/server/com/silkplm/rpc/healthcheck/methods/ExposedMethods.ExposedMethods
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param s {number} 
     * @param i {number} 
     * @param l {number} 
     * @param f {number} 
     * @param d {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     basicTypes(s, i, l, f, d) {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/basic-types', [s, i, l, f, d]);
    }
    /** 
     * @async
     * @param x {module:src/server/com/silkplm/rpc/healthcheck/methods/ComplexType.ComplexType} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/healthcheck/methods/ComplexType.ComplexType>}
     */
     complexInOut(x) {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/complex-in-out', [x]);
    }
    /** 
     * @async
     * @param x {module:src/server/com/silkplm/rpc/healthcheck/methods/ComplexType.ComplexType} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     complexInputMethod(x) {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/complex-input-method', [x]);
    }
    /** 
     * @async
     * @param x {module:src/server/com/silkplm/rpc/healthcheck/methods/ArgumentObject.ArgumentObject[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     listOfObjectsMethod(x) {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/list-of-objects-method', [x]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     npeExceptionMethod() {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/npe-exception-method', []);
    }
    /** 
     * @async
     * @param x {module:src/server/com/silkplm/rpc/healthcheck/methods/ArgumentObject.ArgumentObject} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     objectMethod(x) {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/object-method', [x]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/healthcheck/methods/BusinessException.BusinessException}
     * @returns {Promise<string>}
     */
     rpcExceptionMethod() {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/rpc-exception-method', []);
    }
    /** 
     * @async
     * @param x {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     simpleMethod(x) {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/simple-method', [x]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     voidMethod() {
            return RpcClass.rpcCall('/rpc/healthcheck/methods/exposed-methods/void-method', []);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.healthcheck.methods.ExposedMethods';
metadata.__type_short__ = 'ExposedMethods';
ExposedMethods.prototype.__metadata__ = metadata;

ExposedMethods.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/healthcheck/methods/ExposedMethods */
export default ExposedMethods

export { ExposedMethods }
